import axios from "axios";
import { domain_article } from "../../util/Constants";
import { domain } from "../../util/Constants";


const ArticleAPI = {
    getAllArticles({ page, lang }) {
        lang = lang ? lang:'en';
        page = page ? page : 1;
        return axios({
            url: `${domain_article}/get-all-articles?page=${page}&lang=${lang}&limit=10`,
            method: "GET"
        }).catch(e => {
            console.log('Catch error on get all article\n', e.message);
            return 'Error';
        });
    },
    getAllEbooks({ page, lang }) {
        lang = lang ? lang:'en';
        page = page ? page : 1;
        return axios({
            url: `${domain_article}/get-all-articles?type_id=2&page=${page}&lang=${lang}&limit=9`,
            method: "GET"
        }).catch(e => {
            console.log('Catch error on get all ebook\n', e.message);
            return 'Error';
        });
    },
    getArticleById({ id, lang }) {
        lang = lang ? lang:'en';
        id = id ? id : 1;
        return axios({
            url: `${domain_article}/get-article-detail?article_id=${id}&lang=${lang}`,
            method: "GET"
        }).catch(e => {
            console.log('Catch error on get article by id\n', e.message);
            return 'Error';
        });
    },

    getAllOnlineExhibitions({ branch, page, lang }) {
        lang = lang ? lang:'en';
        page = page ? page : 1;
        branch = branch ? branch : 1;
        return axios({
            url: `${domain}/resource_center/online_exhibition_by_branch?branch_id=${branch}&page=${page}&lang=${lang}`,
            method: "GET"
        }).catch(e => {
            console.log('Catch error on get all online exhibitions\n', e.message);
            return 'Error';
        });
    },
    getOnlineExhibitionsById({ id, lang }) {
        lang = lang ? lang:'en';
        id = id ? id : 1;
        return axios({
            url: `${domain}/resource_center/online_exhibition_by_id/${id}&lang=${lang}`,
            method: "GET"
        }).catch(e => {
            console.log('Catch error on get online exhibition by id\n', e.message);
            return 'Error';
        });
    },
};

export default ArticleAPI;
